import React from 'react'
import styled, { css } from 'styled-components'

const width = '14'
const height = '16'
const viewBox = '0 0 14 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g key="g" fill="#000" clipPath="url(#a)">
      <path d="M10.907 16H0v-2.187c.227-.167.443-.36.686-.492.193-.106.254-.222.254-.452C.932 9.287.933 5.704.935 2.122c0-1.265.79-2.117 1.969-2.12C4.712 0 6.519 0 8.327.002c1.158.002 1.933.835 1.937 2.077.003.895.006 1.791-.003 2.687-.003.192.038.292.222.357a2.32 2.32 0 0 1 1.382 1.303c.15.348.245.752.254 1.134.031 1.26.01 2.52.013 3.78 0 .397.174.634.456.642.292.009.477-.237.478-.65.002-1.896-.002-3.791.004-5.687.001-.18-.06-.272-.197-.365-.49-.335-.777-.8-.721-1.468-.21-.115-.43-.225-.64-.352-.274-.166-.36-.418-.246-.677.12-.27.379-.365.669-.215.594.307 1.181.628 1.77.946.2.108.294.28.294.528-.003 2.499.001 4.998-.005 7.498a1.416 1.416 0 0 1-.675 1.236c-.926.603-2.104-.096-2.116-1.263-.013-1.301 0-2.603-.005-3.905-.002-.705-.397-1.314-.934-1.451 0 2.095.021 4.188-.014 6.28-.01.55.094.9.608 1.066.248.08.35.298.342.585-.011.416-.016.834.002 1.25.012.288-.073.504-.295.662Zm-.656-1.01c.045-.667.053-.685-.45-.925-.35-.166-.476-.407-.475-.82.013-3.688.008-7.374.007-11.06 0-.812-.35-1.185-1.105-1.186h-5.19c-.817 0-1.172.38-1.173 1.253 0 3.53.002 7.06-.002 10.59-.001 1.016.122.91-.757 1.377-.073.04-.155.135-.166.214-.025.18-.008.366-.008.556h9.319Z" />
      <path d="M5.591 7.499c-.738 0-1.476.002-2.214 0-.416-.002-.574-.175-.575-.628-.002-1.249-.002-2.497 0-3.745 0-.45.16-.623.579-.624 1.476-.002 2.952-.002 4.427 0 .436 0 .59.168.59.643V6.86c0 .471-.155.638-.593.639-.738.002-1.476 0-2.214 0Zm1.864-3.978h-3.7v2.963h3.7V3.521Z" />
    </g>,
    <defs key="defs">
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v16H0z" />
      </clipPath>
    </defs>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconFuel'
})
